<app-dialog
  #dialog
  [key]="'client-access'"
  [action]="'client-access'"
  [headerTheme]="'simple'"
  [title]="title()"
  [appendTo]="'body'"
  [maxWidth]="'480px'">
  <!--
    `appAutoFormGroup` é OBRIGATÓRIO junto com o `[formGroup]`: sem ele os `app-input` criam
    controles próprios e o formulário do componente fica vazio, com o botão travado (ver
    `modal-partner-user`).
  -->
  <div class="p-4" [formGroup]="form" appAutoFormGroup>
    <div class="row">
      <div class="col-12">
        <app-input
          [type]="'text'"
          [label]="'Nome do contato'"
          [placeholder]="'Nome e sobrenome'"
          [controlName]="'name'"
          [required]="true"></app-input>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12">
        <app-input
          [type]="'email'"
          [label]="'E-mail'"
          [placeholder]="'nome@empresa.com.br'"
          [controlName]="'email'"
          [required]="true"></app-input>
        <small class="d-block mt-1 text-muted">
          É o login do cliente. Ele recebe neste endereço o link para criar a senha e, pela área do
          cliente, assina o NDA + carta SCR.
        </small>
      </div>
    </div>
  </div>

  <ng-template #footer>
    <div class="dialog__footer">
      <app-button
        label="Cancelar"
        theme="outline-grey"
        [type]="'button'"
        [disabled]="saving()"
        (sendButtonClick)="dialogRef?.close()" />
      <app-button
        [disabled]="!isFormValid()"
        [isLoading]="saving()"
        [loadingText]="'Enviando...'"
        [label]="'Enviar convite'"
        [type]="'button'"
        (sendButtonClick)="submitAction()"></app-button>
    </div>
  </ng-template>
</app-dialog>
